import React from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import DteTestProgressAdminTable from '../../components/Hacienda/DteTestProgressAdmin/DteTestProgressAdminTable';

const DteTestProgressAdminPage: React.FC = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <DteTestProgressAdminTable />
    </DefaultLayout>
  );
};

export default DteTestProgressAdminPage;
